import React, { useState } from 'react';

const FlowChartModals = ({
  showAIPrompt,
  setShowAIPrompt,
  aiPrompt,
  setAiPrompt,
  aiMode,
  setAiMode,
  selectedCode,
  setSelectedCode,
  handleGenerateCode,
  isGeneratingCode,
  aiStatus,
  showFunctionLibraryModal,
  setShowFunctionLibraryModal,
  functionLibrary,
  setFunctionLibrary,
  isLoadingFunctionLibrary,
  functionLibraryError,
  setFunctionLibraryError,
  showFxGroupsModal,
  setShowFxGroupsModal,
  fxGroups,
  setFxGroups,
  fxGroupsError,
  setFxGroupsError,
  selectedFxGroup,
  setSelectedFxGroup,
  functions,
  setFunctions,
  isLoadingFxGroups,
  isLoadingFunctions,
  functionsError,
  setFunctionsError,
  selectedFunction,
  setSelectedFunction,
  showFunctionsModal,
  setShowFunctionsModal,
  fetchFunctions,
  fetchFunctionScript,
  showIncludeModal,
  setShowIncludeModal,
  selectedIncludeShape,
  setSelectedIncludeShape,
  includeFoldersData,
  setIncludeFoldersData,
  isLoadingIncludeData,
  includeError,
  setIncludeError,
  selectedIncludePath,
  setSelectedIncludePath,
  selectedFolder,
  setSelectedFolder,
  includeFilesData,
  setIncludeFilesData,
  isLoadingFiles,
  selectedFile,
  setSelectedFile,
  activeTabId,
  setTabs,
  workflowDataRef,
  graphRef,
  createAttachIcon,
  mxCellOverlay,
  mxConstants,
  mxPoint,
  mxEvent,
  openIncludeDetails,
  shapeIncludePaths,
  setShapeIncludePaths,
  shapeIncludeFolders,
  setShapeIncludeFolders,
  shapeOriginalLabels,
  setShapeOriginalLabels,
  shapesWithInclude,
  setShapesWithInclude,
  fetchWrapper,
  navigate,
  showIncludeInfoModal,
  setShowIncludeInfoModal,
  includeInfoData,
  setIncludeInfoData,
}) => {
  const [fxGroupSearch, setFxGroupSearch] = useState('');
  const [functionSearch, setFunctionSearch] = useState('');
  const [includeFolderSearch, setIncludeFolderSearch] = useState('');
  const [includeFileSearch, setIncludeFileSearch] = useState('');

  return (
    <>
      {/* AI Prompt Modal */}
      {showAIPrompt && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 100000,
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowAIPrompt(false);
              setAiPrompt('');
            }
          }}
        >
          <div
            style={{
              background: '#2d2d2d',
              borderRadius: 8,
              padding: 24,
              width: '90%',
              maxWidth: 600,
              border: '1px solid #3e3e42',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 16,
              }}
            >
              <h3 style={{ color: '#cccccc', margin: 0, fontSize: 18, fontWeight: 600 }}>
                {aiMode === 'modify' ? '✏️ AI ile Kodu Değiştir' : '🤖 AI ile Kod Üret'}
              </h3>
              <button
                onClick={() => {
                  setShowAIPrompt(false);
                  setAiPrompt('');
                  setSelectedCode(null);
                  setAiMode('generate');
                }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#888',
                  fontSize: 24,
                  cursor: 'pointer',
                  padding: 0,
                  width: 30,
                  height: 30,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ×
              </button>
            </div>

            {selectedCode && aiMode === 'modify' && (
              <div
                style={{
                  marginBottom: 16,
                  padding: 12,
                  background: '#1e1e1e',
                  border: '1px solid #3e3e42',
                  borderRadius: 4,
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    color: '#888',
                    marginBottom: 8,
                    fontWeight: 500,
                  }}
                >
                  📝 Seçili Kod:
                </div>
                <pre
                  style={{
                    margin: 0,
                    padding: 8,
                    background: '#0d1117',
                    borderRadius: 4,
                    fontSize: 11,
                    color: '#c9d1d9',
                    overflow: 'auto',
                    maxHeight: 150,
                    fontFamily: 'Monaco, Menlo, "Courier New", monospace',
                  }}
                >
                  {selectedCode.text}
                </pre>
              </div>
            )}

            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: 'block',
                  color: '#cccccc',
                  fontSize: 13,
                  marginBottom: 8,
                  fontWeight: 500,
                }}
              >
                {aiMode === 'modify' ? 'Bu kodu nasıl değiştirmek istiyorsunuz?' : 'Ne yapmak istiyorsunuz?'}
              </label>
              <textarea
                value={aiPrompt}
                onChange={(e) => setAiPrompt(e.target.value)}
                placeholder={
                  aiMode === 'modify'
                    ? 'Örn: Bu fonksiyonu async yap, try-catch ekle, bu değişkeni refactor et, bu kodu optimize et...'
                    : 'Örn: Bir veritabanı bağlantısı oluştur, kullanıcı girişi kontrolü yap, veri filtreleme fonksiyonu yaz...'
                }
                style={{
                  width: '100%',
                  minHeight: 120,
                  padding: 12,
                  background: '#1e1e1e',
                  border: '1px solid #3e3e42',
                  borderRadius: 4,
                  color: '#cccccc',
                  fontSize: 13,
                  fontFamily: 'inherit',
                  resize: 'vertical',
                }}
                onKeyDown={(e) => {
                  if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
                    e.preventDefault();
                    handleGenerateCode();
                  }
                }}
              />
              <div
                style={{
                  marginTop: 8,
                  fontSize: 11,
                  color: '#888',
                }}
              >
                💡 İpucu: Ctrl+Enter ile kod üretebilirsiniz
              </div>
            </div>

            {aiStatus.error && (
              <div
                style={{
                  padding: 12,
                  background: '#5a1e1e',
                  color: '#ff7070',
                  borderRadius: 4,
                  marginBottom: 16,
                  fontSize: 12,
                }}
              >
                ❌ {aiStatus.error}
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowAIPrompt(false);
                  setAiPrompt('');
                  setSelectedCode(null);
                  setAiMode('generate');
                }}
                style={{
                  background: '#3e3e42',
                  border: 'none',
                  color: '#cccccc',
                  padding: '8px 16px',
                  borderRadius: 4,
                  fontSize: 13,
                  cursor: 'pointer',
                }}
              >
                İptal
              </button>
              <button
                onClick={handleGenerateCode}
                disabled={!aiPrompt.trim() || isGeneratingCode}
                style={{
                  background: isGeneratingCode
                    ? '#555'
                    : aiMode === 'modify'
                      ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
                      : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  border: 'none',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: 4,
                  fontSize: 13,
                  cursor: isGeneratingCode ? 'not-allowed' : 'pointer',
                  opacity: !aiPrompt.trim() || isGeneratingCode ? 0.6 : 1,
                  fontWeight: 500,
                }}
              >
                {isGeneratingCode
                  ? '⏳ İşleniyor...'
                  : aiMode === 'modify'
                    ? '✏️ Kodu Değiştir'
                    : '✨ Kod Üret'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Function Library Modal */}
      {showFunctionLibraryModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 100002,
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowFunctionLibraryModal(false);
              setFunctionLibrary(null);
              setFunctionLibraryError(null);
            }
          }}
        >
          <div
            style={{
              background: '#2d2d2d',
              borderRadius: 8,
              padding: 24,
              width: '90%',
              maxWidth: 1000,
              maxHeight: '80vh',
              border: '1px solid #3e3e42',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 20,
              }}
            >
              <h3 style={{ color: '#cccccc', margin: 0, fontSize: 18, fontWeight: 600 }}>
                📚 Function Kütüphanesi
              </h3>
              <button
                onClick={() => {
                  setShowFunctionLibraryModal(false);
                  setFunctionLibrary(null);
                  setFunctionLibraryError(null);
                }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#888',
                  fontSize: 24,
                  cursor: 'pointer',
                  padding: 0,
                  width: 30,
                  height: 30,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ×
              </button>
            </div>

            <div
              style={{
                flex: 1,
                overflow: 'auto',
                background: '#1e1e1e',
                borderRadius: 4,
                padding: 16,
                marginBottom: 16,
              }}
            >
              {isLoadingFunctionLibrary && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px 20px',
                    color: '#888',
                  }}
                >
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      border: '3px solid #3e3e42',
                      borderTopColor: '#8b5cf6',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      marginBottom: 16,
                    }}
                  />
                  <div style={{ fontSize: 13 }}>Function kütüphanesi yükleniyor...</div>
                </div>
              )}

              {functionLibraryError && (
                <div
                  style={{
                    padding: 20,
                    background: '#5a1e1e',
                    borderRadius: 4,
                    color: '#ff7070',
                    fontSize: 13,
                    marginBottom: 16,
                  }}
                >
                  ❌ {functionLibraryError}
                </div>
              )}

              {!isLoadingFunctionLibrary && !functionLibraryError && functionLibrary && (
                <div
                  style={{
                    color: '#cccccc',
                    fontSize: 14,
                  }}
                >
                  <pre
                    style={{
                      margin: 0,
                      padding: 12,
                      background: '#0d1117',
                      borderRadius: 4,
                      fontSize: 12,
                      color: '#c9d1d9',
                      overflow: 'auto',
                      maxHeight: '60vh',
                      fontFamily: 'Monaco, Menlo, "Courier New", monospace',
                    }}
                  >
                    {JSON.stringify(functionLibrary, null, 2)}
                  </pre>
                </div>
              )}

              {!isLoadingFunctionLibrary && !functionLibraryError && !functionLibrary && (
                <div
                  style={{
                    padding: 20,
                    textAlign: 'center',
                    color: '#888',
                    fontSize: 13,
                  }}
                >
                  Function kütüphanesi bulunamadı.
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowFunctionLibraryModal(false);
                  setFunctionLibrary(null);
                  setFunctionLibraryError(null);
                }}
                style={{
                  background: '#3e3e42',
                  border: 'none',
                  color: '#cccccc',
                  padding: '8px 16px',
                  borderRadius: 4,
                  fontSize: 13,
                  cursor: 'pointer',
                }}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Fx Groups Modal */}
      {showFxGroupsModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 100002,
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowFxGroupsModal(false);
              setFxGroups([]);
              setFxGroupsError(null);
              setSelectedFxGroup(null);
              setFunctions([]);
              setFunctionsError(null);
              setSelectedFunction(null);
              setShowFunctionsModal(false);
            }
          }}
        >
          <div
            style={{
              background: '#2d2d2d',
              borderRadius: 8,
              padding: 24,
              width: '90%',
              maxWidth: 800,
              maxHeight: '80vh',
              border: '1px solid #3e3e42',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 20,
              }}
            >
              <h3 style={{ color: '#cccccc', margin: 0, fontSize: 18, fontWeight: 600 }}>🔧 Fx Groups</h3>
              <button
                onClick={() => {
                  setShowFxGroupsModal(false);
                  setFxGroups([]);
                  setFxGroupsError(null);
                  setSelectedFxGroup(null);
                  setFunctions([]);
                  setFunctionsError(null);
                  setSelectedFunction(null);
                  setShowFunctionsModal(false);
                }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#888',
                  fontSize: 24,
                  cursor: 'pointer',
                  padding: 0,
                  width: 30,
                  height: 30,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ×
              </button>
            </div>

            <div
              style={{
                flex: 1,
                overflow: 'auto',
                background: '#1e1e1e',
                borderRadius: 4,
                padding: 16,
                marginBottom: 16,
              }}
            >
              {isLoadingFxGroups && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px 20px',
                    color: '#888',
                  }}
                >
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      border: '3px solid #3e3e42',
                      borderTopColor: '#8b5cf6',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      marginBottom: 16,
                    }}
                  />
                  <div style={{ fontSize: 13 }}>Fx groups yükleniyor...</div>
                </div>
              )}

              {fxGroupsError && (
                <div
                  style={{
                    padding: 20,
                    background: '#3a1f1f',
                    border: '1px solid #5a2a2a',
                    borderRadius: 4,
                    color: '#ff6b6b',
                    fontSize: 13,
                  }}
                >
                  <div style={{ fontWeight: 600, marginBottom: 8 }}>Hata:</div>
                  <div>{fxGroupsError}</div>
                </div>
              )}

              {!isLoadingFxGroups && !fxGroupsError && fxGroups.length > 0 && (
                <div>
                  {/* Search box */}
                  <div style={{ position: 'relative', marginBottom: 12 }}>
                    <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#666', fontSize: 13 }}>🔍</span>
                    <input
                      type="text"
                      placeholder="Grup ara..."
                      value={fxGroupSearch}
                      onChange={(e) => setFxGroupSearch(e.target.value)}
                      style={{
                        width: '100%',
                        background: '#1a1a1a',
                        border: '1px solid #3e3e42',
                        borderRadius: 4,
                        color: '#cccccc',
                        fontSize: 13,
                        padding: '7px 10px 7px 32px',
                        outline: 'none',
                        boxSizing: 'border-box',
                      }}
                      onFocus={(e) => { e.target.style.borderColor = '#8b5cf6'; }}
                      onBlur={(e) => { e.target.style.borderColor = '#3e3e42'; }}
                    />
                    {fxGroupSearch && (
                      <button
                        onClick={() => setFxGroupSearch('')}
                        style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#666', cursor: 'pointer', fontSize: 16, lineHeight: 1 }}
                      >×</button>
                    )}
                  </div>
                  <div
                    style={{
                      color: '#888',
                      fontSize: 11,
                      marginBottom: 10,
                    }}
                  >
                    {fxGroups.filter(g => !fxGroupSearch || g.toLowerCase().includes(fxGroupSearch.toLowerCase())).length} / {fxGroups.length} grup
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 8,
                    }}
                  >
                    {fxGroups.filter(g => !fxGroupSearch || g.toLowerCase().includes(fxGroupSearch.toLowerCase())).map((group, index) => (
                      <div
                        key={index}
                        style={{
                          background: selectedFxGroup === group ? '#3e3e42' : '#2d2d2d',
                          border: `1px solid ${selectedFxGroup === group ? '#8b5cf6' : '#3e3e42'}`,
                          borderRadius: 4,
                          padding: '12px 16px',
                          color: '#cccccc',
                          fontSize: 13,
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                        }}
                        onClick={() => {
                          fetchFunctions(group);
                        }}
                        onMouseEnter={(e) => {
                          if (selectedFxGroup !== group) {
                            e.currentTarget.style.background = '#3e3e42';
                            e.currentTarget.style.borderColor = '#8b5cf6';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedFxGroup !== group) {
                            e.currentTarget.style.background = '#2d2d2d';
                            e.currentTarget.style.borderColor = '#3e3e42';
                          }
                        }}
                      >
                        {group}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {!isLoadingFxGroups && !fxGroupsError && fxGroups.length === 0 && (
                <div
                  style={{
                    padding: 20,
                    textAlign: 'center',
                    color: '#888',
                    fontSize: 13,
                  }}
                >
                  Fx groups bulunamadı.
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowFxGroupsModal(false);
                  setFxGroups([]);
                  setFxGroupsError(null);
                  setSelectedFxGroup(null);
                  setFunctions([]);
                  setFunctionsError(null);
                  setSelectedFunction(null);
                  setShowFunctionsModal(false);
                }}
                style={{
                  background: '#3e3e42',
                  border: 'none',
                  color: '#cccccc',
                  padding: '8px 16px',
                  borderRadius: 4,
                  fontSize: 13,
                  cursor: 'pointer',
                }}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Functions Modal */}
      {showFunctionsModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 100002,
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowFunctionsModal(false);
              setFunctions([]);
              setFunctionsError(null);
              setSelectedFunction(null);
            }
          }}
        >
          <div
            style={{
              background: '#2d2d2d',
              borderRadius: 8,
              padding: 24,
              width: '90%',
              maxWidth: 800,
              maxHeight: '85vh',
              border: '1px solid #3e3e42',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 20,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <button
                  onClick={() => {
                    setShowFunctionsModal(false);
                    setFunctions([]);
                    setFunctionsError(null);
                    setSelectedFunction(null);
                    setShowFxGroupsModal(true);
                  }}
                  style={{
                    background: 'transparent',
                    border: '1px solid #3e3e42',
                    color: '#cccccc',
                    padding: '6px 12px',
                    borderRadius: 4,
                    fontSize: 12,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                  }}
                >
                  <span>←</span>
                  <span>Geri</span>
                </button>
                <h3 style={{ color: '#cccccc', margin: 0, fontSize: 18, fontWeight: 600 }}>
                  🔧 Functions - {selectedFxGroup}
                </h3>
              </div>
              <button
                onClick={() => {
                  setShowFunctionsModal(false);
                  setFunctions([]);
                  setFunctionsError(null);
                  setSelectedFunction(null);
                }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#888',
                  fontSize: 24,
                  cursor: 'pointer',
                  padding: 0,
                  width: 30,
                  height: 30,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ×
              </button>
            </div>

            <div
              style={{
                flex: 1,
                overflowY: 'auto',
                padding: '0 4px',
              }}
            >
              {isLoadingFunctions && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px 20px',
                    color: '#888',
                  }}
                >
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      border: '3px solid #3e3e42',
                      borderTopColor: '#8b5cf6',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      marginBottom: 16,
                    }}
                  />
                  <div style={{ fontSize: 13 }}>Functions yükleniyor...</div>
                </div>
              )}

              {functionsError && (
                <div
                  style={{
                    padding: 20,
                    background: '#3a1f1f',
                    border: '1px solid #5a2a2a',
                    borderRadius: 4,
                    color: '#ff6b6b',
                    fontSize: 13,
                    marginBottom: 20,
                  }}
                >
                  <div style={{ fontWeight: 600, marginBottom: 8 }}>Hata:</div>
                  <div>{functionsError}</div>
                </div>
              )}

              {!isLoadingFunctions && !functionsError && functions.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {/* Search box */}
                  <div style={{ position: 'relative', marginBottom: 4 }}>
                    <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#666', fontSize: 13 }}>🔍</span>
                    <input
                      type="text"
                      placeholder="Fonksiyon ara..."
                      value={functionSearch}
                      onChange={(e) => setFunctionSearch(e.target.value)}
                      style={{
                        width: '100%',
                        background: '#1a1a1a',
                        border: '1px solid #3e3e42',
                        borderRadius: 4,
                        color: '#cccccc',
                        fontSize: 13,
                        padding: '7px 10px 7px 32px',
                        outline: 'none',
                        boxSizing: 'border-box',
                      }}
                      onFocus={(e) => { e.target.style.borderColor = '#8b5cf6'; }}
                      onBlur={(e) => { e.target.style.borderColor = '#3e3e42'; }}
                    />
                    {functionSearch && (
                      <button
                        onClick={() => setFunctionSearch('')}
                        style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#666', cursor: 'pointer', fontSize: 16, lineHeight: 1 }}
                      >×</button>
                    )}
                  </div>
                  {functions.filter(f => !functionSearch || (f.fname || '').toLowerCase().includes(functionSearch.toLowerCase()) || (f.fdesc || '').toLowerCase().includes(functionSearch.toLowerCase())).map((func, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setSelectedFunction(func.fname);
                        fetchFunctionScript(func);
                      }}
                      style={{
                        padding: '12px 16px',
                        borderRadius: 4,
                        background: selectedFunction === func.fname ? '#3e3e42' : '#2d2d2d',
                        border: `1px solid ${selectedFunction === func.fname ? '#8b5cf6' : '#3e3e42'}`,
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                      }}
                      onMouseEnter={(e) => {
                        if (selectedFunction !== func.fname) {
                          e.currentTarget.style.background = '#3e3e42';
                          e.currentTarget.style.borderColor = '#8b5cf6';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (selectedFunction !== func.fname) {
                          e.currentTarget.style.background = '#2d2d2d';
                          e.currentTarget.style.borderColor = '#3e3e42';
                        }
                      }}
                    >
                      <div
                        style={{
                          color: '#cccccc',
                          fontSize: 13,
                          fontWeight: 500,
                          marginBottom: 4,
                        }}
                      >
                        {func.fname}
                      </div>
                      {func.fdesc && (
                        <div
                          style={{
                            color: '#888',
                            fontSize: 11,
                            fontStyle: 'italic',
                          }}
                        >
                          {func.fdesc}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {!isLoadingFunctions && !functionsError && functions.length === 0 && (
                <div
                  style={{
                    padding: 20,
                    textAlign: 'center',
                    color: '#888',
                    fontSize: 13,
                  }}
                >
                  Functions bulunamadı.
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
              <button
                onClick={() => {
                  setShowFunctionsModal(false);
                  setFunctions([]);
                  setFunctionsError(null);
                  setSelectedFunction(null);
                }}
                style={{
                  background: '#3e3e42',
                  border: 'none',
                  color: '#cccccc',
                  padding: '8px 16px',
                  borderRadius: 4,
                  fontSize: 13,
                  cursor: 'pointer',
                }}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Include Modal */}
      {showIncludeModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 100001,
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowIncludeModal(false);
              setSelectedIncludeShape(null);
              setSelectedIncludePath(null);
              setSelectedFolder(null);
              setIncludeFilesData(null);
              setSelectedFile(null);
              setIncludeFoldersData(null);
              setIncludeError(null);
            }
          }}
        >
          <div
            style={{
              background: '#2d2d2d',
              borderRadius: 8,
              padding: 24,
              width: '90%',
              maxWidth: 800,
              maxHeight: '80vh',
              border: '1px solid #3e3e42',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 20,
              }}
            >
              <h3 style={{ color: '#cccccc', margin: 0, fontSize: 18, fontWeight: 600 }}>🔗 Add Include</h3>
              <button
                onClick={() => {
                  setShowIncludeModal(false);
                  setSelectedIncludeShape(null);
                  setSelectedIncludePath(null);
                  setSelectedFolder(null);
                  setIncludeFilesData(null);
                  setSelectedFile(null);
                  setIncludeFoldersData(null);
                  setIncludeError(null);
                }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#888',
                  fontSize: 24,
                  cursor: 'pointer',
                  padding: 0,
                  width: 30,
                  height: 30,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ×
              </button>
            </div>

            <div
              style={{
                flex: 1,
                overflow: 'auto',
                background: '#1e1e1e',
                borderRadius: 4,
                padding: 16,
                marginBottom: 16,
              }}
            >
              <div
                style={{
                  color: '#888',
                  fontSize: 13,
                  marginBottom: 12,
                }}
              >
                Seçili Şekil: {selectedIncludeShape}
              </div>

              {isLoadingIncludeData && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px 20px',
                    color: '#888',
                  }}
                >
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      border: '3px solid #3e3e42',
                      borderTopColor: '#0e639c',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      marginBottom: 16,
                    }}
                  />
                  <div style={{ fontSize: 13 }}>Folder ve file listesi yükleniyor...</div>
                </div>
              )}

              {includeError && (
                <div
                  style={{
                    padding: 20,
                    background: '#5a1e1e',
                    borderRadius: 4,
                    color: '#ff7070',
                    fontSize: 13,
                    marginBottom: 16,
                  }}
                >
                  ❌ {includeError}
                </div>
              )}

              {!isLoadingIncludeData && !includeError && includeFoldersData && !selectedFolder && (
                <div
                  style={{
                    color: '#cccccc',
                    fontSize: 14,
                  }}
                >
                  {(() => {
                    try {
                      let foldersList = [];
                      if (Array.isArray(includeFoldersData)) {
                        foldersList = includeFoldersData;
                      } else if (includeFoldersData.result && Array.isArray(includeFoldersData.result)) {
                        foldersList = includeFoldersData.result;
                      } else if (includeFoldersData.data && Array.isArray(includeFoldersData.data)) {
                        foldersList = includeFoldersData.data;
                      } else if (typeof includeFoldersData === 'string') {
                        try {
                          const parsed = JSON.parse(includeFoldersData);
                          if (Array.isArray(parsed)) {
                            foldersList = parsed;
                          } else if (parsed.result && Array.isArray(parsed.result)) {
                            foldersList = parsed.result;
                          }
                        } catch (e) {
                          return (
                            <div
                              style={{
                                padding: 12,
                                background: '#2d2d2d',
                                borderRadius: 4,
                                color: '#cccccc',
                                fontSize: 12,
                                fontFamily: 'monospace',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                              }}
                            >
                              {includeFoldersData}
                            </div>
                          );
                        }
                      }

                      const filteredFolders = foldersList.filter((f) => {
                        if (!includeFolderSearch) return true;
                        const name = (f.folderName || f.name || '').toLowerCase();
                        return name.includes(includeFolderSearch.toLowerCase());
                      });

                      if (foldersList.length === 0) {
                        return (
                          <div
                            style={{
                              padding: 20,
                              textAlign: 'center',
                              color: '#888',
                              fontSize: 13,
                            }}
                          >
                            Folder bulunamadı.
                          </div>
                        );
                      }

                      return (
                        <div style={{ display: 'grid', gap: 8 }}>
                          {/* Folder arama kutusu */}
                          <div style={{ position: 'relative', marginBottom: 4 }}>
                            <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#666', fontSize: 13 }}>🔍</span>
                            <input
                              type="text"
                              placeholder="Folder ara..."
                              value={includeFolderSearch}
                              onChange={(e) => setIncludeFolderSearch(e.target.value)}
                              style={{
                                width: '100%',
                                background: '#1a1a1a',
                                border: '1px solid #3e3e42',
                                borderRadius: 4,
                                color: '#cccccc',
                                fontSize: 13,
                                padding: '7px 10px 7px 32px',
                                outline: 'none',
                                boxSizing: 'border-box',
                              }}
                              onFocus={(e) => { e.target.style.borderColor = '#0e639c'; }}
                              onBlur={(e) => { e.target.style.borderColor = '#3e3e42'; }}
                            />
                            {includeFolderSearch && (
                              <button
                                onClick={() => setIncludeFolderSearch('')}
                                style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#666', cursor: 'pointer', fontSize: 16, lineHeight: 1 }}
                              >×</button>
                            )}
                          </div>
                          {filteredFolders.length === 0 && (
                            <div style={{ padding: '12px 0', textAlign: 'center', color: '#666', fontSize: 12 }}>
                              "{includeFolderSearch}" için sonuç bulunamadı.
                            </div>
                          )}
                          {filteredFolders.map((folder, index) => {
                            const folderId = folder.folderId || folder.id || String(index);
                            const folderName = folder.folderName || folder.name || 'Unnamed';
                            const isSelected = selectedIncludePath === folderId;

                            return (
                              <div
                                key={folderId}
                                onClick={() => {
                                  setSelectedIncludePath(folderId);
                                  setSelectedFolder(folder);
                                  setSelectedFile(null);
                                }}
                                style={{
                                  padding: '12px 16px',
                                  background: isSelected ? '#0e639c' : 'transparent',
                                  border: isSelected ? '2px solid #3e9fdb' : '1px solid #3e3e42',
                                  borderRadius: 6,
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 12,
                                  transition: 'all 0.2s',
                                }}
                                onMouseEnter={(e) => {
                                  if (!isSelected) {
                                    e.currentTarget.style.background = '#3e3e42';
                                    e.currentTarget.style.borderColor = '#555';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!isSelected) {
                                    e.currentTarget.style.background = 'transparent';
                                    e.currentTarget.style.borderColor = '#3e3e42';
                                  }
                                }}
                              >
                                <div style={{ fontSize: 18 }}>📁</div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ fontWeight: 500 }}>{folderName}</div>
                                  <div style={{ fontSize: 11, color: '#888' }}>ID: {folderId}</div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    } catch (error) {
                      return (
                        <div
                          style={{
                            padding: 20,
                            textAlign: 'center',
                            color: '#ff7070',
                            fontSize: 13,
                          }}
                        >
                          Folder listesi render edilemedi: {error.message}
                        </div>
                      );
                    }
                  })()}
                </div>
              )}

              {!isLoadingIncludeData && !includeError && selectedFolder && (
                <div style={{ color: '#cccccc', fontSize: 14 }}>
                  <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <button
                      onClick={() => {
                        setSelectedFolder(null);
                        setSelectedFile(null);
                        setIncludeFilesData(null);
                        setSelectedIncludePath(null);
                        setIncludeFileSearch('');
                      }}
                      style={{
                        background: 'transparent',
                        border: '1px solid #3e3e42',
                        color: '#cccccc',
                        padding: '4px 8px',
                        borderRadius: 4,
                        fontSize: 11,
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                      }}
                    >
                      ← Geri
                    </button>
                    <span>
                      Folder: {selectedFolder.folderName || selectedFolder.foldername || selectedFolder.name || 'Unknown'}
                    </span>
                  </div>

                  {isLoadingFiles && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '30px 20px',
                        color: '#888',
                      }}
                    >
                      <div
                        style={{
                          width: 30,
                          height: 30,
                          border: '3px solid #3e3e42',
                          borderTopColor: '#0e639c',
                          borderRadius: '50%',
                          animation: 'spin 1s linear infinite',
                          marginBottom: 12,
                        }}
                      />
                      <div style={{ fontSize: 12 }}>File listesi yükleniyor...</div>
                    </div>
                  )}

                  {!isLoadingFiles && includeFilesData && (
                    <div style={{ display: 'grid', gap: 6 }}>
                      {/* File arama kutusu */}
                      <div style={{ position: 'relative', marginBottom: 4 }}>
                        <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#666', fontSize: 13 }}>🔍</span>
                        <input
                          type="text"
                          placeholder="Dosya ara..."
                          value={includeFileSearch}
                          onChange={(e) => setIncludeFileSearch(e.target.value)}
                          style={{
                            width: '100%',
                            background: '#1a1a1a',
                            border: '1px solid #3e3e42',
                            borderRadius: 4,
                            color: '#cccccc',
                            fontSize: 13,
                            padding: '7px 10px 7px 32px',
                            outline: 'none',
                            boxSizing: 'border-box',
                          }}
                          onFocus={(e) => { e.target.style.borderColor = '#0e639c'; }}
                          onBlur={(e) => { e.target.style.borderColor = '#3e3e42'; }}
                        />
                        {includeFileSearch && (
                          <button
                            onClick={() => setIncludeFileSearch('')}
                            style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#666', cursor: 'pointer', fontSize: 16, lineHeight: 1 }}
                          >×</button>
                        )}
                      </div>

                      {(() => {
                        try {
                          let filesList = [];
                          if (Array.isArray(includeFilesData)) {
                            filesList = includeFilesData;
                          } else if (includeFilesData?.result && Array.isArray(includeFilesData.result)) {
                            filesList = includeFilesData.result;
                          } else if (includeFilesData?.data && Array.isArray(includeFilesData.data)) {
                            filesList = includeFilesData.data;
                          }

                          const filteredFiles = filesList.filter((f) => {
                            if (!includeFileSearch) return true;
                            const name = (f.filename || f.fileName || f.name || '').toLowerCase();
                            return name.includes(includeFileSearch.toLowerCase());
                          });

                          if (filesList.length === 0) {
                            return (
                              <div style={{ padding: 20, textAlign: 'center', color: '#888', fontSize: 13 }}>
                                File bulunamadı.
                              </div>
                            );
                          }

                          if (filteredFiles.length === 0) {
                            return (
                              <div style={{ padding: '12px 0', textAlign: 'center', color: '#666', fontSize: 12 }}>
                                "{includeFileSearch}" için sonuç bulunamadı.
                              </div>
                            );
                          }

                          return filteredFiles.map((file, index) => {
                            const fileId = file.diagrun_id || file.fileId || file.id || String(index);
                            const fileName = file.filename || file.fileName || file.name || `File ${index + 1}`;
                            const isSelected = selectedFile === fileId || selectedFile === fileName;

                            return (
                              <div
                                key={fileId}
                                onClick={() => {
                                  setSelectedFile(fileId);
                                }}
                                style={{
                                  padding: '10px 12px',
                                  background: isSelected ? '#0e639c' : 'transparent',
                                  border: isSelected ? '2px solid #3e9fdb' : '1px solid #3e3e42',
                                  borderRadius: 6,
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 10,
                                  transition: 'all 0.2s',
                                }}
                                onMouseEnter={(e) => {
                                  if (!isSelected) {
                                    e.currentTarget.style.background = '#3e3e42';
                                    e.currentTarget.style.borderColor = '#555';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!isSelected) {
                                    e.currentTarget.style.background = 'transparent';
                                    e.currentTarget.style.borderColor = '#3e3e42';
                                  }
                                }}
                              >
                                <div style={{ fontSize: 16 }}>📄</div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ fontWeight: 500 }}>{fileName}</div>
                                  <div style={{ fontSize: 11, color: '#888' }}>ID: {fileId}</div>
                                </div>
                              </div>
                            );
                          });
                        } catch (error) {
                          return (
                            <div style={{ padding: 20, textAlign: 'center', color: '#ff7070', fontSize: 13 }}>
                              File listesi render edilemedi: {error.message}
                            </div>
                          );
                        }
                      })()}
                    </div>
                  )}
                </div>
              )}

              {!isLoadingIncludeData && !includeError && !includeFoldersData && (
                <div
                  style={{
                    padding: 20,
                    textAlign: 'center',
                    color: '#888',
                    fontSize: 13,
                  }}
                >
                  Veri bulunamadı.
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowIncludeModal(false);
                  setSelectedIncludeShape(null);
                  setSelectedIncludePath(null);
                  setSelectedFolder(null);
                  setIncludeFilesData(null);
                  setSelectedFile(null);
                  setSelectedFolder(null);
                  setIncludeFilesData(null);
                  setSelectedFile(null);
                  setIncludeFoldersData(null);
                  setIncludeError(null);
                }}
                style={{
                  background: '#3e3e42',
                  border: 'none',
                  color: '#cccccc',
                  padding: '8px 16px',
                  borderRadius: 4,
                  fontSize: 13,
                  cursor: 'pointer',
                }}
              >
                İptal
              </button>
              <button
                onClick={() => {
                  if (!selectedFile) {
                    alert('Lütfen bir file seçin!');
                    return;
                  }

                  let filesList = [];
                  if (Array.isArray(includeFilesData)) {
                    filesList = includeFilesData;
                  } else if (includeFilesData?.result && Array.isArray(includeFilesData.result)) {
                    filesList = includeFilesData.result;
                  } else if (includeFilesData?.data && Array.isArray(includeFilesData.data)) {
                    filesList = includeFilesData.data;
                  }

                  const selectedFileData = filesList.find(
                    (f) => (f.diagrun_id || f.fileId || f.id || f.name) === selectedFile,
                  );
                  const fileName =
                    selectedFileData?.filename || selectedFileData?.fileName || selectedFileData?.name || selectedFile;
                  const diagrunId = selectedFileData?.diagrun_id || selectedFile;

                  if (selectedIncludeShape && diagrunId) {
                    const addInclude = async () => {
                      try {
                        const processId = process.env.REACT_APP_ADD_INCLUDABLE_LAST_SELECT;
                        if (!processId) {
                          throw new Error('REACT_APP_ADD_INCLUDABLE_LAST_SELECT environment variable tanımlı değil!');
                        }

                        const bodyParams = {
                          stepid: selectedIncludeShape,
                          include: diagrunId,
                          process: processId,
                        };

                        const response = await fetchWrapper(processId, bodyParams, navigate);

                        const resultData = response?.result;
                        const isSuccess =
                          resultData &&
                          (resultData.result === 1 || resultData.result === '1') &&
                          (resultData.message === 'success' || resultData.message === 'Success');

                        if (response && isSuccess) {
                          const includePath = diagrunId;
                          const foldername = selectedFolder?.folderName || selectedFolder?.foldername || '';

                          if (activeTabId) {
                            setTabs((prev) =>
                              prev.map((tab) => {
                                if (tab.id !== activeTabId) return tab;
                                const currentData = tab.workflowData || workflowDataRef.current;
                                if (!currentData?.contents) return tab;
                                const updatedContents = currentData.contents.map((item) => {
                                  if (!item || String(item.id) !== String(selectedIncludeShape)) {
                                    return item;
                                  }
                                  return {
                                    ...item,
                                    include: includePath,
                                    filename: fileName || item.filename || '',
                                    foldername: foldername || item.foldername || item.folderName || '',
                                  };
                                });
                                return {
                                  ...tab,
                                  workflowData: {
                                    ...currentData,
                                    contents: updatedContents,
                                  },
                                };
                              }),
                            );
                          }

                          setShapeIncludePaths((prev) => ({
                            ...prev,
                            [selectedIncludeShape]: includePath,
                          }));

                          setShapeIncludeFolders((prev) => ({
                            ...prev,
                            [selectedIncludeShape]: foldername,
                          }));

                          setShapesWithInclude((prev) => new Set([...prev, selectedIncludeShape]));

                          if (graphRef.current) {
                            const graph = graphRef.current;
                            const model = graph.getModel();
                            const cell = model.getCell(selectedIncludeShape);

                            if (cell && model.isVertex(cell)) {
                              const currentLabel = cell.getValue() ? String(cell.getValue()) : '';
                              setShapeOriginalLabels((prev) => ({
                                ...prev,
                                [selectedIncludeShape]: currentLabel,
                              }));

                              model.beginUpdate();
                              try {
                                cell.setValue(fileName);
                                graph.refresh(cell);
                              } finally {
                                model.endUpdate();
                              }

                              graph.removeCellOverlay(cell);

                              const attachIcon = createAttachIcon();

                              const overlay = new mxCellOverlay(
                                attachIcon,
                                'Include edildi',
                                mxConstants.ALIGN_RIGHT,
                                mxConstants.ALIGN_BOTTOM,
                                new mxPoint(-2, -2),
                              );

                              overlay.addListener(mxEvent.CLICK, function (sender, evt) {
                                const overlayCell = evt.getProperty('cell');
                                if (overlayCell) {
                                  openIncludeDetails(overlayCell.getId(), { showPopup: false });
                                }
                              });

                              graph.addCellOverlay(cell, overlay);

                              graph.getView().invalidate(cell);
                              graph.getView().validate();
                              graph.refresh();
                            }
                          }
                        } else {
                          throw new Error(response?.message || 'Include ekleme başarısız');
                        }
                      } catch (error) {
                        alert(`Include eklenirken hata oluştu: ${error.message}`);
                        return;
                      }
                    };

                    addInclude()
                      .then(() => {
                        setShowIncludeModal(false);
                        setSelectedIncludeShape(null);
                        setSelectedIncludePath(null);
                        setSelectedFolder(null);
                        setIncludeFilesData(null);
                        setSelectedFile(null);
                        setIncludeFoldersData(null);
                        setIncludeError(null);
                      })
                      .catch(() => {});
                  } else {
                    setShowIncludeModal(false);
                    setSelectedIncludeShape(null);
                    setSelectedIncludePath(null);
                    setSelectedFolder(null);
                    setIncludeFilesData(null);
                    setSelectedFile(null);
                    setIncludeFoldersData(null);
                    setIncludeError(null);
                  }
                }}
                disabled={!selectedFile}
                style={{
                  background: selectedFile ? '#0e639c' : '#3e3e42',
                  border: 'none',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: 4,
                  fontSize: 13,
                  cursor: selectedFile ? 'pointer' : 'not-allowed',
                  fontWeight: 500,
                  opacity: selectedFile ? 1 : 0.5,
                }}
              >
                Include Ekle {selectedFile && `(${selectedFile})`}
              </button>
            </div>
          </div>
        </div>
      )}

      {showIncludeInfoModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 100002,
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowIncludeInfoModal(false);
              setIncludeInfoData(null);
            }
          }}
        >
          <div
            style={{
              background: '#2d2d2d',
              borderRadius: 8,
              padding: 20,
              width: '90%',
              maxWidth: 520,
              border: '1px solid #3e3e42',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 16,
              }}
            >
              <h3 style={{ color: '#cccccc', margin: 0, fontSize: 16, fontWeight: 600 }}>🔎 Include Bilgisi</h3>
              <button
                onClick={() => {
                  setShowIncludeInfoModal(false);
                  setIncludeInfoData(null);
                }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#888',
                  fontSize: 22,
                  cursor: 'pointer',
                  padding: 0,
                  width: 28,
                  height: 28,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ×
              </button>
            </div>
            <div
              style={{
                background: '#1e1e1e',
                borderRadius: 4,
                padding: 12,
                color: '#cccccc',
                fontSize: 13,
                display: 'grid',
                gridTemplateColumns: '120px 1fr',
                rowGap: 10,
                columnGap: 10,
              }}
            >
              <div style={{ color: '#888' }}>Shape ID</div>
              <div>{includeInfoData?.shapeId || '—'}</div>
              <div style={{ color: '#888' }}>Include ID</div>
              <div>{includeInfoData?.include || '—'}</div>
              <div style={{ color: '#888' }}>Folder</div>
              <div>{includeInfoData?.foldername || '—'}</div>
              <div style={{ color: '#888' }}>Filename</div>
              <div>{includeInfoData?.filename || '—'}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FlowChartModals;
